import { StoreFinder } from '@/commons/component/store-finder';
import { SlidingPanel } from './../../modules-es5/commons/layout/sliding-panel';
import { getIdModel, getIdSku } from './pdp-utils';

let storePanelIsInited = false;
const isHK = cube.env.country === 'HK';

// eslint-disable-next-line import/no-mutable-exports
export let panel = null;

export function openPanel() {
  if (!storePanelIsInited) initPanel();
  else panel.open();
}

const initStoreFinder = () => {

  const templateKey = cube.$('.buying-zone--cnc1h') ? 'pdp-cnc1h' : 'pdp-nocnc1h';

  const storeFinder = new StoreFinder({
    container: cube.$('.dkt-sliding-panel-inner .store-selection'),
    template: templateKey,
    product: {
      idModel: getIdModel,
      idSku: getIdSku,
    },
  });


  // refresh result when when model / size
  cube.event.on('sizeChanged', () => {
    if (storeFinder.displayedStores.length) storeFinder.seeMoreStores(0);
  });
  cube.event.on('modelChanged', () => {
    if (storeFinder.displayedStores.length) storeFinder.seeMoreStores(0);
  });

  storeFinder.onClick(
    '.js-login-and-redirect a',
    ({ event, productInfo, element }) => {
      event.preventDefault();
      cube.storage.setItem('skuBeforeLogin', productInfo.idSku);

      const storeId = element.closest('.js-store-result').dataset.idStore;

      element.closest('.store-selection__login-invite').classList.add('store-selection__login-invite--processing');

      cube.stores
        .setDefaultStore(storeId)
        .then(document.location.href = element.href);

    }
  );

  storeFinder.onClick('.js-select-store', (event) => {
    const storeId = event.store.store_id;
    cube.stores
      .setDefaultStore(storeId)
      .then(() => {
        window.dispatchEvent(new CustomEvent('store-selected', event));
        panel.close();
      });
  });
};

function initPanel() {
  const storeSelectionTemplate = cube.$('.store-selection');
  const panelContentClone = storeSelectionTemplate.cloneNode(true);

  // constuct and update var
  storeSelectionTemplate.parentNode.removeChild(storeSelectionTemplate);

  panel = new SlidingPanel();
  panel.init({
    content: panelContentClone,
    destroyOnClose: false,
    name: 'store-selection-panel',
    title: isHK ? window.Messages('storeselection.selectYourStore') : window.Messages('storeselection.panelTitle'),
  });

  storePanelIsInited = true;

  initStoreFinder();
}



// WEBPACK FOOTER //
// ./src/catalog/product-details/pdp-store_selection-finder.js